var React = require('react');

function ArrowDownRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M441.9 250.1l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L250 385.4V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v341.4L42.9 230.3c-4.7-4.7-12.3-4.7-17 0L6.1 250.1c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"}));
}

ArrowDownRegular.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"arrow-down","className":"svg-inline--fa fa-arrow-down fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = ArrowDownRegular;

ArrowDownRegular.default = ArrowDownRegular;
